import { FC, HTMLAttributes } from "react";
import clsx from "classnames";
import { Typography, TypographyVariant, Image, Icon } from "@onmo/ui";
import GameRepresent from "../../../assets/leaderboard/game-represent.webp";
import GameRepresent2x from "../../../assets/leaderboard/game-represent@2x.webp";
import GameRepresent3x from "../../../assets/leaderboard/game-represent@3x.webp";
import Gems from "../../../assets/leaderboard/gems.webp";
import Gems2x from "../../../assets/leaderboard/gems@2x.webp";
import Gems3x from "../../../assets/leaderboard/gems@3x.webp";
import Cup from "../../../assets/leaderboard/cup.webp";
import Cup2x from "../../../assets/leaderboard/cup@2x.webp";
import Cup3x from "../../../assets/leaderboard/cup@3x.webp";
import { useStyles } from "./GuideWinGems.style";
import { useTranslation } from "react-i18next";

export const GuideWinGems: FC<HTMLAttributes<HTMLDivElement>> = (props) => {
  const { className, ...otherProps } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={clsx(classes.root, className)} {...otherProps}>
      <Typography variant={TypographyVariant.HeadingH6Bold}>
        {t("how_to_win_gems_heading")}
      </Typography>
      <div className={classes.steps}>
        <div className={classes.card}>
          <Typography variant={TypographyVariant.BodyB3Bold}>1</Typography>
          <Typography
            variant={TypographyVariant.BodyB5Regular}
            className={classes.desc}
          >
            {t("play_any_game")}
          </Typography>
          <Image
            src={GameRepresent}
            src2x={GameRepresent2x}
            src3x={GameRepresent3x}
          />
        </div>
        <Icon name="icon-linear-arrow-right" />
        <div className={classes.card}>
          <Typography variant={TypographyVariant.BodyB3Bold}>2</Typography>
          <Typography
            variant={TypographyVariant.BodyB5Regular}
            className={classes.desc}
          >
            {t("collect_gems")}
          </Typography>
          <Image src={Gems} src2x={Gems2x} src3x={Gems3x} />
        </div>
        <Icon name="icon-linear-arrow-right" />
        <div className={classes.card}>
          <Typography variant={TypographyVariant.BodyB3Bold}>3</Typography>
          <Typography
            variant={TypographyVariant.BodyB5Regular}
            className={classes.desc}
          >
            {t("redeem_prizes")}
          </Typography>
          <Image src={Cup} src2x={Cup2x} src3x={Cup3x} />
        </div>
      </div>
    </div>
  );
};
